import React, { useState } from 'react';
import { SyntheticEvent } from 'react';
import { Grid, Tabs, Tab } from '@mui/material';
import { TabPanel, TabContext } from '@mui/lab';
import { SectionTitle } from '../../design-library';
import { Contest } from '../../core/contests/types';
import ContestConfig from './Contest/ContestConfig';
import Judges from './Contest/Judges';
import Contestants from './Contest/Contestants';
import CsvFileUploader from './CreateUsers/FIleUploader';
import BalloonView from './Contest/BalloonView';

export default function ContestForm({
	type,
	initFormData,
	handleSubmit,
}: {
	type: 'create' | 'edit';
	initFormData: Contest;
	handleSubmit: (data: Contest) => Promise<Contest>;
}) {
	const [value, setValue] = useState('1');

	const handleChange = (event: SyntheticEvent<Element, Event>, newValue: string) => {
		setValue(newValue);
	};

	return (
		<Grid container alignItems='center' justifyContent='center'>
			<Grid
				item
				container
				direction='row'
				xs={12}
				sm={11}
				md={10}
				lg={11}
				xl={10}
				sx={{ minWidth: '450px', maxWidth: '1800px' }}
				rowSpacing={'2px'}
			>
				<Grid item xs={12}>
					<SectionTitle title={`${type === 'create' ? 'Create new' : 'Edit'} contest`} size='small' />
				</Grid>
				<TabContext value={value}>
					<Grid item xs={12}>
						<Tabs value={value} onChange={handleChange} aria-label='contest tabs'>
							<Tab label='Config' value='1' />
							<Tab label='Judges' value='2' />
							<Tab label='Contestants' value='3' />
							<Tab label='Bulk Upload' value='4' />
							<Tab label='Balloons' value='5' />
						</Tabs>
					</Grid>
					<TabPanel value='1' sx={{ width: '100%', padding: 0 }}>
						<ContestConfig type={type} initFormData={initFormData} handleSubmit={handleSubmit} />
					</TabPanel>
					<TabPanel value='2' sx={{ width: '100%', padding: 0 }}>
						<Judges contestId={initFormData.id} />
					</TabPanel>
					<TabPanel value='3' sx={{ width: '100%', padding: 0 }}>
						<Contestants contestId={initFormData.id} />
					</TabPanel>
					<TabPanel value='4' sx={{ width: '100%', padding: 0 }}>
						<CsvFileUploader contest_id={initFormData.id!} />
					</TabPanel>
					<TabPanel value='5' sx={{ width: '100%', padding: 0 }}>
						<BalloonView contest={initFormData} />
					</TabPanel>
				</TabContext>
			</Grid>
		</Grid>
	);
}
